import { ZidpayApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new ZidpayApiService(ApiClientFactory());

export function ZidpayApiServiceFactory(): typeof service {
  return service;
}
